import { mergeSharedPlaceSettings, type CurrencyCode } from './sharedPlaceSettings'
import { mergeOrderModeSettings } from './orderModeSettings'
import { defaultPrintFormatBundle } from './printFormats/types'
import { defaultInvoiceProfile } from './invoiceProfile'

export const DEFAULT_CHIME_SOURCE_PREFS = {
  chimeOnPendingFromThisDevice: false,
  chimeOnPendingFromCustomerApp: true,
  chimeOnPendingFromOtherPos: true,
  chimeOnPendingFromDelivery: false,
}

/** Browser- and server-safe defaults. Return fresh nested objects for each outlet. */
export function defaultPlaceSettings(setup?: { timezone: string; currency: CurrencyCode }) {
  const shared = mergeSharedPlaceSettings(setup)
  return {
    confirmMoveToProcessingMessage: 'Confirm move to processing? Payment will be requested.',
    onProcessActions: [
      { id: 'barista', label: 'Barista cup label printer', type: 'barista_cup_label' },
      { id: 'kitchen', label: 'Kitchen receipt printer', type: 'kitchen_receipt' },
    ],
    currency: shared.currency,
    shared,
    orderModeSettings: mergeOrderModeSettings(null),
    printFormats: defaultPrintFormatBundle(),
    invoiceProfile: defaultInvoiceProfile(),
    newOrderChimeVolume: 0.7,
    ...DEFAULT_CHIME_SOURCE_PREFS,
  }
}
